import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import * as Highcharts from 'highcharts';
import {Options} from 'highcharts';
import {InsightsService} from "../../services/insights/insights.service";
import {AlertBannerService, AlertType} from "../../lib/alert-banner";

@Component({
  selector: 'app-pulse-nps-overall',
  templateUrl: './pulse-nps-overall.component.pug',
  styleUrls: ['./pulse-nps-overall.component.scss'],
  standalone: false
})

export class PulseNpsOverallComponent implements OnInit, OnChanges {

  @Input() start!: any;
  @Input() end!: any;
  @Input() request: any;
  @Input() survey: any;
  @Input() department: any;
  @Input() filterBy!: any;
  @Input() pause_load = false;
  @Output() dataLoaded = new EventEmitter<void>();
  data = '-';

  constructor(private insightsService: InsightsService,
              private alertList: AlertBannerService) {}

  ngOnInit(): void {
    }

  private loadAndSetData() {
    if (this.pause_load) {
      this.emitDataLoaded();
      return;
    }
    this.insightsService.getPulseNPSOverall(this.start, this.end, this.request, this.department, this.survey).subscribe(data => {
      this.data = data['overall'];
      this.emitDataLoaded();
    }, error => {
      console.log(error);
      this.data = '-';
      this.alertList.append([{
        type: AlertType.DANGER,
        message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
        keepOnRouteChange: true
      }]);
      this.emitDataLoaded();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.loadAndSetData();
  }

  private emitDataLoaded(): void {
    this.dataLoaded.emit();
  }
}
